"use client";
import { css as i } from "@emotion/react";
import o from "@emotion/styled";
import { SPACINGS as r } from "../../../tokens/spacings/Spacings.js";
const s = o.div(
  ({ feSize: t }) => i`
		display: grid;
		gap: ${r.xxs} 0;
		grid: auto / minmax(0, 1fr);
		height: fit-content;

		${t !== "sm" && i`
			label {
				margin-block-end: ${r.xxs};
			}
		`}
	`
);
export {
  s as InputFieldWrapper
};
